import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customCategoryInput", "saveButton"]

  connect() {
    const category = this.element.children[1].childNodes[0]
    const customCategoryValue = this.customCategoryInputTarget.value
    if (customCategoryValue != "") {
      const option = document.createElement("option")
      option.value = customCategoryValue
      option.text = customCategoryValue
      option.selected = true
      category.appendChild(option)
    } else {
      const option = document.createElement("option")
      option.value = "other"
      option.text = "Benutzerdefiniert"
      category.appendChild(option)
    }
  }

  inputChanged() {
    const allowedCategories = ["work", "fax", "mobile", "private", "invoice"]
    const category = this.element.children[1].childNodes[0].value
    const customCategory = this.customCategoryInputTarget
    const saveButton = this.saveButtonTarget
    if (!allowedCategories.includes(category)) {
      if (customCategory.classList.contains("hidden")) {
        customCategory.classList.remove("hidden")
        saveButton.classList.remove("hidden")
      }
    } else {
      customCategory.classList.add("hidden")
      saveButton.classList.add("hidden")
    }
  }

  setOption() {
    const category = this.element.children[1].childNodes[0]
    const customCategory = this.customCategoryInputTarget
    const customCategoryValue = customCategory.value
    const saveButton = this.saveButtonTarget

    const allowedCategories = ["work", "fax", "mobile", "private", "invoice"]
    Array.from(category.options).forEach((option) => {
      if (!allowedCategories.includes(option.value)) {
        option.remove()
      }
    })

    const option = document.createElement("option")
    option.value = customCategoryValue
    option.text = customCategoryValue
    option.selected = true
    category.appendChild(option)
    customCategory.classList.add("hidden")
    saveButton.classList.add("hidden")
  }
}
